__turbopack_context__.v({
  "jobTimelineStep": "_2i1Muq_jobTimelineStep",
  "jobTimelineStep__controls": "_2i1Muq_jobTimelineStep__controls",
  "jobTimelineStep__dateControls": "_2i1Muq_jobTimelineStep__dateControls",
  "jobTimelineStep__deliverableCellLabel": "_2i1Muq_jobTimelineStep__deliverableCellLabel",
  "jobTimelineStep__deliverableEditorRow": "_2i1Muq_jobTimelineStep__deliverableEditorRow",
  "jobTimelineStep__footer": "_2i1Muq_jobTimelineStep__footer",
  "jobTimelineStep__header": "_2i1Muq_jobTimelineStep__header",
  "jobTimelineStep__panel": "_2i1Muq_jobTimelineStep__panel",
  "jobTimelineStep__scaleControls": "_2i1Muq_jobTimelineStep__scaleControls",
  "jobTimelineStep__slider": "_2i1Muq_jobTimelineStep__slider",
  "jobTimelineStep__subtitle": "_2i1Muq_jobTimelineStep__subtitle",
  "jobTimelineStep__title": "_2i1Muq_jobTimelineStep__title",
});
